// GENERATED by fritz2 - NEVER CHANGE CONTENT MANUALLY!
package de.oevbs.kunde.kundenportal2.model.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.partner.model.AcademicTitle
import de.oevbs.businesspartner.bpcrmservice2.partner.model.Address
import de.oevbs.businesspartner.bpcrmservice2.partner.model.NamePrefix
import de.oevbs.businesspartner.bpcrmservice2.partner.model.Salutation
import dev.fritz2.core.Lens
import dev.fritz2.core.lensOf
import kotlin.Boolean
import kotlin.String
import kotlinx.datetime.LocalDate

public fun ContactInformation.Companion.salutation(): Lens<ContactInformation, Salutation> = lensOf(
    "salutation",
    { it.salutation },
    { p, v -> p.copy(salutation = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.salutation(): Lens<PARENT, Salutation> = this +
    ContactInformation.salutation()

public fun ContactInformation.Companion.title(): Lens<ContactInformation, AcademicTitle> = lensOf(
    "title",
    { it.title },
    { p, v -> p.copy(title = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.title(): Lens<PARENT, AcademicTitle> = this +
    ContactInformation.title()

public fun ContactInformation.Companion.firstName(): Lens<ContactInformation, String> = lensOf(
    "firstName",
    { it.firstName },
    { p, v -> p.copy(firstName = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.firstName(): Lens<PARENT, String> = this +
    ContactInformation.firstName()

public fun ContactInformation.Companion.namePrefix(): Lens<ContactInformation, NamePrefix> = lensOf(
    "namePrefix",
    { it.namePrefix },
    { p, v -> p.copy(namePrefix = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.namePrefix(): Lens<PARENT, NamePrefix> = this +
    ContactInformation.namePrefix()

public fun ContactInformation.Companion.lastName(): Lens<ContactInformation, String> = lensOf(
    "lastName",
    { it.lastName },
    { p, v -> p.copy(lastName = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.lastName(): Lens<PARENT, String> = this +
    ContactInformation.lastName()

public fun ContactInformation.Companion.dateOfBirth(): Lens<ContactInformation, LocalDate> = lensOf(
    "dateOfBirth",
    { it.dateOfBirth },
    { p, v -> p.copy(dateOfBirth = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.dateOfBirth(): Lens<PARENT, LocalDate> = this +
    ContactInformation.dateOfBirth()

public fun ContactInformation.Companion.address(): Lens<ContactInformation, Address> = lensOf(
    "address",
    { it.address },
    { p, v -> p.copy(address = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.address(): Lens<PARENT, Address> = this +
    ContactInformation.address()

public fun ContactInformation.Companion.addressSuggestion(): Lens<ContactInformation, Address> =
    lensOf(
    "addressSuggestion",
    { it.addressSuggestion },
    { p, v -> p.copy(addressSuggestion = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.addressSuggestion(): Lens<PARENT, Address> =
    this + ContactInformation.addressSuggestion()

public fun ContactInformation.Companion.forceUseUserInputAddress():
    Lens<ContactInformation, Boolean> = lensOf(
    "forceUseUserInputAddress",
    { it.forceUseUserInputAddress },
    { p, v -> p.copy(forceUseUserInputAddress = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.forceUseUserInputAddress():
    Lens<PARENT, Boolean> = this + ContactInformation.forceUseUserInputAddress()

public fun ContactInformation.Companion.phone(): Lens<ContactInformation, String> = lensOf(
    "phone",
    { it.phone },
    { p, v -> p.copy(phone = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.phone(): Lens<PARENT, String> = this +
    ContactInformation.phone()

public fun ContactInformation.Companion.mobile(): Lens<ContactInformation, String> = lensOf(
    "mobile",
    { it.mobile },
    { p, v -> p.copy(mobile = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.mobile(): Lens<PARENT, String> = this +
    ContactInformation.mobile()

public fun ContactInformation.Companion.mail(): Lens<ContactInformation, String> = lensOf(
    "mail",
    { it.mail },
    { p, v -> p.copy(mail = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.mail(): Lens<PARENT, String> = this +
    ContactInformation.mail()

public fun ContactInformation.Companion.mailConfirm(): Lens<ContactInformation, String> = lensOf(
    "mailConfirm",
    { it.mailConfirm },
    { p, v -> p.copy(mailConfirm = v)}
  )

public fun <PARENT> Lens<PARENT, ContactInformation>.mailConfirm(): Lens<PARENT, String> = this +
    ContactInformation.mailConfirm()
